import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import FormLoader from '@activebrands/core-web/components/FormLoader';
import Gtm from '@activebrands/core-web/components/Gtm';
import { usePageLoad } from '@activebrands/core-web/hooks/lifecycle';
import { init as searchInsightsInit } from '@activebrands/core-web/libs/algolia/searchInsights';
import { FEATURE_FLAGS } from '@activebrands/core-web/state/features/types';
import { getConnectionTimeout } from '@activebrands/core-web/utils/timings';
import Optimizely from '@activebrands/core-web/components/Optimizely';
import { RealUserMonitoringComponent } from '@grebban/pagespeedplus/react/RealUserMonitoringComponent';


const ThirdPartyScripts = () => {
    const [render, setRender] = useState(false);
    const flags = useSelector(state => state.features);

    usePageLoad(() => {
        if (!render) {
            setTimeout(() => setRender(true), getConnectionTimeout());
        }
    });

    useEffect(() => {
        searchInsightsInit();
    }, []);

    return (
        <>
            {/* Load essential third party scripts without delay */}
            {flags[FEATURE_FLAGS.OPTIMIZELY] && <Optimizely />}
            {flags[FEATURE_FLAGS.FORMLOADER] && <FormLoader />}
            {flags[FEATURE_FLAGS.GTM] && <Gtm />}

            {/* Load all other third party scripts after page load*/}
            {render ? <></> : null}
			{flags[FEATURE_FLAGS.PAGE_SPEED_PLUS] && (
                        <RealUserMonitoringComponent debug siteId={process.env.REACT_APP_PAGE_REAL_USER_MONITORING_SITE_ID} />
                    )}
        </>
    );
};

export default ThirdPartyScripts;
